var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { $ } from '../simpli';
import { classToClass } from 'class-transformer';
import Papa from 'papaparse';
var shortid = require('shortid');
export { sha256 as encrypt } from 'js-sha256';
export function uid(prefix, suffix) {
    return "" + (prefix || '') + shortid.generate() + (suffix || '');
}
export function sleep(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
export function clone(fromEntity, options) {
    return classToClass(fromEntity, options);
}
export function buildResource($id, $tag) {
    return { $id: $id, $tag: $tag };
}
export function listObject(obj, i18nPath) {
    return Object.keys(obj)
        .filter(function (val) { return isNaN(Number(val)); })
        .map(function (key) { return ({ $id: obj[key], $tag: i18nPath ? $.t(i18nPath + "." + key) : key }); });
}
export function createCsvFile(filename, csvStr) {
    var csvData = new Blob(["\uFEFF" + csvStr], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(csvData, filename);
    }
    else {
        var link = document.createElement('a');
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(csvData);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
export function csvToNormalizedData(urlOrFile, blueprint) {
    return __awaiter(this, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, csvToData(urlOrFile)];
                case 1:
                    resp = _a.sent();
                    return [2 /*return*/, normalizeData(resp.data, blueprint)];
            }
        });
    });
}
export function csvToData(urlOrFile) {
    return __awaiter(this, void 0, void 0, function () {
        var promiseFunc;
        return __generator(this, function (_a) {
            promiseFunc = function (resolve, reject) {
                var defaultConfig = {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) { return resolve(results); },
                    error: function (error) { return reject(error); },
                };
                if (urlOrFile instanceof File) {
                    Papa.parse(urlOrFile, __assign({}, defaultConfig));
                }
                else {
                    Papa.parse(urlOrFile, __assign({ download: true }, defaultConfig));
                }
            };
            return [2 /*return*/, new Promise(promiseFunc)];
        });
    });
}
export function normalizeData(data, blueprint) {
    return (data
        .map(function (dataItem) {
        var normDataItem = {};
        for (var key in blueprint) {
            if (blueprint.hasOwnProperty(key)) {
                var allowedKeys = blueprint[key];
                var keyFromData = allowedKeys.find(function (k) { return dataItem[k]; });
                if (keyFromData) {
                    normDataItem[key] = dataItem[keyFromData];
                }
            }
        }
        return normDataItem;
    })
        // clean invalid rows
        .filter(function (item) { return item !== undefined && item !== null; }));
}
export function copyToClipboard(text) {
    var el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}
//# sourceMappingURL=utils.helper.js.map